import React, { FC } from 'react';
import { Alert, Button, Form, Modal } from 'react-bootstrap';
import { APIBASEURL } from '../../common/constant';
import { storeAdminToken } from '../../common/auth';

interface IAdminLoginModalProps {
  show: boolean;
  onSuccess: () => void;
  onHide: () => void;
}

const AdminLoginModal: FC<IAdminLoginModalProps> = ({ show, onSuccess, onHide }) => {
  const [password, setPassword] = React.useState('');
  const [error, setError] = React.useState<string | null>(null);
  const [loading, setLoading] = React.useState(false);

  const handleLogin = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(`${APIBASEURL()}/api/auth`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password }),
      });

      if (response.ok) {
        const data = await response.json() as { token: string };
        storeAdminToken(data.token);
        setPassword('');
        onSuccess();
      } else if (response.status === 401) {
        setError('Incorrect password.');
      } else {
        setError('Login failed. Please try again.');
      }
    } catch {
      setError('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && password && !loading) {
      void handleLogin();
    }
  };

  const handleHide = () => {
    setPassword('');
    setError(null);
    onHide();
  };

  return (
    <Modal show={show} onHide={handleHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Admin Login</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <Alert variant="danger">{error}</Alert>}
        <Form.Group>
          <Form.Label>Password</Form.Label>
          <Form.Control
            type="password"
            placeholder="Enter admin password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyDown={handleKeyDown}
            autoFocus
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleHide}>
          Cancel
        </Button>
        <Button
          variant="primary"
          onClick={() => void handleLogin()}
          disabled={!password || loading}
        >
          {loading ? 'Logging in…' : 'Login'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AdminLoginModal;
